import React, { useEffect } from "react";
import { Outlet, NavLink, matchRoutes, useLocation } from "react-router-dom";
import { Card } from "antd";

//------------------------------------------css
import "./style.css";
import { FiLogOut, FiUser, FiArchive, FiCreditCard } from "react-icons/fi";

//------------------------------------------icons
// import { Key, User, List, LogOut } from '../../images/icons';
import Context from "../../context/profileContext";
import { useLocale } from "antd/es/locale";

const profileItems = [
  { title: "حساب کاربری", route: "/profile", icon: <FiUser /> },
  { title: "نوبت‌های من", route: "/profile/history", icon: <FiArchive /> },
  { title: "اطلاعات بانکی", route: "/profile/wallet", icon: <FiCreditCard /> },
  {
    title: "تراکنش‌ها",
    route: "/profile/transactions",
    icon: <FiCreditCard />,
  },
];

const Profile = () => {
  const { profileTitle, changeTitle } = React.useContext(Context);

  return (
    <div className="doctors-page-container single-doctor-page-container">
      <div class="row">
        {/* sidebar */}

        <SideBar changeTitle={changeTitle} />
        <div class="col-lg-9 department-description-container profile-container">
          <div className="profile-header">{profileTitle}</div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Profile;

const SideBar = (props) => {
  const location = useLocation();
  // const [{ route }] = matchRoutes(routes, location)
  const logout = async () => {
    await localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    props.changeTitle(
      profileItems.find((item) => item.route === location.pathname)?.title
    );
  }, []);

  return (
    <div class="col-lg-3 sidebar profile-sidebar">
      <Card className="profile-sidebar">
        <div className="profile-sidebar-header">
          <img src={require("../../assets/images/defaultProfile.jpg")} />
          <h5>{localStorage.getItem('cellphone')}</h5>
        </div>
        <div className="profile-sidebar-container">
          {profileItems.map((item) => (
            <NavLink
              onClick={() => props.changeTitle(item.title)}
              end
              to={item.route}
              className={({ isActive }) =>
                isActive
                  ? "profile-sidebar-item profile-active-item"
                  : "profile-sidebar-item"
              }
            >
              {item.icon}
              {item.title}
            </NavLink>
          ))}
          <a
            style={{ cursor: "pointer" }}
            onClick={() => logout()}
            className="profile-sidebar-item"
          >
            <FiLogOut />
            خروج
          </a>
        </div>
      </Card>
    </div>
  );
};
